<template>
  <BenchmarkingWidget
    :area="props.area"
    :zone="props.zone"
    :widget="props.widget"
    :valueType="'time'"
  >
    <template #icon>
      <IconClock style="width: 100%; height: 100%" />
    </template>
    <template #label>
      <div class="widget__label">Total Engaged Dwell Time</div>
    </template>
  </BenchmarkingWidget>
</template>

<script setup lang="ts">
import type { WidgetFilter, WidgetTypeVisits, WidgetSetting } from '@/types/Widget';
import IconClock from '@/icons/analytics/IconClock.svg?component';
import BenchmarkingWidget from './BenchmarkingWidget.vue';

const props = defineProps<{
  widget: WidgetTypeVisits;
  area?: WidgetFilter;
  zone?: WidgetSetting;
}>();
</script>
